import { render, staticRenderFns } from "./MyHeader.vue?vue&type=template&id=34a811aa&scoped=true"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"
import style0 from "./MyHeader.vue?vue&type=style&index=0&id=34a811aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a811aa",
  null
  
)

export default component.exports